import * as preact from "preact";

import { type PreactPageProps } from "pages/PreactPage";

export default class AttributionsPageView extends preact.Component<PreactPageProps> {
  render() {
    return (
      <>
        <h2>Attributions</h2>
        <small>(incomplete)</small>

        <p>Open source software used to create and run this site:</p>

        <ul class="bullets">
          <li>jQuery</li>
          <li>Node.js and Express</li>
          <li>MongoDB</li>
          <li>Nginx</li>
        </ul>

        <p>Other attributions:</p>

        <ul class="bullets">
          <li>
            Spaced Repetition algorithm inspired by the one used in{" "}
            <a href="http://www.supermemo.com/english/ol/sm2.htm">
              SuperMemo 2
            </a>
          </li>
          <li>
            <a href="http://invokeit.wordpress.com/frequency-word-lists/">
              List of word frequencies from Hermit Date
            </a>
          </li>
          <li>
            <a href="http://how-to-learn-any-language.com/forum/forum_posts.asp?TID=35462&PN=1&TPN=9">
              Catalan and Basque Word frequency lists from Crush, How To Learn
              Any Language Forum
            </a>
          </li>
          <li>
            <a href="http://adamwhitcroft.com/batch/">Batch 300 icons</a>
          </li>
          <li>
            <a href="http://fontawesome.io">Font Awesome by Dave Gandy</a>
          </li>
          <li>
            Loading Indicator gifs from{" "}
            <a href="http://www.ajaxload.info/">ajaxload.info</a>
          </li>
          <li>
            Stock image of open book on landing page used under Creative Commons
            from{" "}
            <a href="http://xooplate.com/template/details/9704-flipping-pages-open-book-vector-icon">
              xooplate.com
            </a>
          </li>
          <li>
            Web Importer uses the{" "}
            <a href="https://github.com/mozilla/readability">
              Readability script
            </a>{" "}
            from Mozilla (adapted from the{" "}
            <a href="https://code.google.com/p/arc90labs-readability/">
              original script from arc90labs
            </a>
            )
          </li>
        </ul>
      </>
    );
  }
}
